function hasGlobalPrivacyControlSignal() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const {
    globalPrivacyControl
  } = navigator;
  return globalPrivacyControl === true || globalPrivacyControl === '1';
}

export { hasGlobalPrivacyControlSignal };
